import { MODAL_HIDE, MODAL_SHOW } from "../../ActionTypes";

export const showModal =
  (template, params, listBotones, posicion, bloquearDissmiss) => (dispatch) => {
    dispatch({
      type: MODAL_SHOW,
      payload: {
        template: template,
        params: params,
        listBotones: listBotones,
        posicion: posicion,
        bloquearDissmiss: bloquearDissmiss,
      },
    });
  };

export const hideModal = () => (dispatch) => {
  dispatch({
    type: MODAL_HIDE,
  });
};

export const hideModalAction = (nextStep) => (dispatch) => {
  dispatch({
    type: MODAL_HIDE,
  });
  // Esperamos un breve tiempo para asegurar que el estado del modal cambie antes de ejecutar nextStep
  setTimeout(() => {
    if (typeof nextStep === 'function') {
      nextStep();
    }
  }, 0);
};
